module.exports = __webpack_public_path__ + "static/media/success.76279587.svg";